import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_API_URL.replace(/\/$/, '')}/api`;

// Create axios instance with default config
const apiService = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

// Add request interceptor to include auth token and view_mode
apiService.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Add view_mode parameter if admin is viewing as user
    const viewMode = localStorage.getItem('viewMode');
    if (viewMode === 'user') {
      // Add view_mode to query params
      config.params = config.params || {};
      config.params.view_mode = 'user';
    }

    // Cache-bust GET requests so browser/proxy never serves stale list/detail data.
    // URL-param only (no Cache-Control header — would trigger CORS preflight the
    // backend doesn't allow). Different _t per request = different cache key.
    if ((config.method || 'get').toLowerCase() === 'get') {
      config.params = config.params || {};
      if (config.params._t === undefined) config.params._t = Date.now();
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle errors
apiService.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle token expiration
    if (error.response?.status === 401) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default apiService;